import { cva, type VariantProps } from "class-variance-authority";
import * as React from "react";
import { cn } from "../../lib/cn";

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-[10px] font-bold uppercase tracking-wide transition-colors",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-[var(--gv-brand)] text-white",
        soft: "border-[var(--gv-brand)]/20 bg-[var(--gv-brand-soft)] text-[var(--gv-brand)]",
        accent:
          "border-[var(--gv-accent)]/30 bg-[var(--gv-accent-soft)] text-[var(--gv-brand)]",
        success:
          "border-emerald-200 bg-emerald-50 text-emerald-800",
        warning: "border-amber-200 bg-amber-50 text-amber-800",
        danger: "border-rose-200 bg-rose-50 text-rose-700",
        outline: "border-[var(--gv-border)] bg-white text-[var(--gv-ink-muted)]",
      },
    },
    defaultVariants: {
      variant: "soft",
    },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

/** Badge / status mashup pill — use across all admin tabs */
export function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <span className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { badgeVariants };
